import { render, staticRenderFns } from "./liveView.vue?vue&type=template&id=3148d881&scoped=true"
import script from "./liveView.vue?vue&type=script&lang=js"
export * from "./liveView.vue?vue&type=script&lang=js"
import style0 from "./liveView.vue?vue&type=style&index=0&id=3148d881&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3148d881",
  null
  
)

export default component.exports